import { Site, SLD } from '@patsnap-utils/biz';
import { stringify } from 'qs';

/**
 *
 * @param id
 * @returns view link
 */
export function generatePatentViewHref(data: {
    patentId: string,
    params?: any,
}) {
    if (!data.patentId) return ''
    const pathname = [
        `view/#/?patentId=${data.patentId}`,
        stringify(data?.params || {})
    ].join('&')
    return new Site({ sld: SLD.EUREKA, pathname }).href
}

export function generatePaperViewHref(data: {
    solutionId: string
}) {
    if (!data.solutionId) return ''
    return new Site({ sld: SLD.EUREKA, pathname: `literature/#/?paperId=${data.solutionId}` }).href
}

export function generateReportViewHref(data: {
    reportId: string
}) {
    if (!data.reportId) return ''
    return new Site({ sld: SLD.EUREKA, pathname: `discovery/#/market-detail/${data.reportId}` }).href
}

export const generateViewHref = generatePatentViewHref;
